import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  padding: 0.75rem 1rem;

  .not-footer {
    flex-grow: 1;
  }
`;

export const Image = styled.img`
  width: 100%;
`;

export const Topbar = styled.div`
  background: ${({ theme }) => theme.qfb4Dark};
  height: 0.5rem;
`;

export default styled.div`
  background-color: rgba(0, 0, 0, 0.95);
  -webkit-box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);
  box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);

  color: black;

  display: flex;
  flex-flow: column;
  flex-basis: 100%;
  margin-bottom: 1rem;

  @media only screen and (min-width: 768px) {
    /* For desktop: */
    flex-basis: 48.5%;
  }

  @media only screen and (min-width: 1024px) {
    /* For desktop: */
    flex-basis: 32.5%;
  }
`;
